import getCheapestRoomData from '@stencil/hotels-utils/src/get-cheapest-room-data';
import {Assign} from 'utility-types';
import {SimilarHotelsAPIResponseTypes} from '../components/SimilarHotels/SimilarHotels';
// import { HotelPolicyDataTypes } from '../utils/fetch-hotel-policy';
// ACTION TYPES
export const UPDATE_RNR_PAGENO = 'UPDATE_RNR_PAGENO';
export const UPDATE_DETAILS_STATIC_DATA = 'UPDATE_DETAILS_STATIC_DATA';
export const UPDATE_DETAILS_HERMES_DATA = 'UPDATE_DETAILS_HERMES_DATA';
export const UPDATE_DETAILS_STATIC_FETCH_STATUS = 'UPDATE_DETAILS_STATIC_FETCH_STATUS';
export const UPDATE_DETAILS_HERMES_FETCH_STATUS = 'UPDATE_DETAILS_HERMES_FETCH_STATUS';
export const UPDATE_CURRENT_ROOM = 'UPDATE_CURRENT_ROOM';
export const UPDATE_DETAILS_CONFIG = 'UPDATE_DETAILS_CONFIG';
export const UPDATE_UGC_IMAGES = 'UPDATE_UGC_IMAGES';
export const RESET_DETAILS_DATA = 'RESET_DETAILS_DATA';

// hotel policy
export const UPDATE_HOTEL_POLICY_LIST = 'UPDATE_HOTEL_POLICY_LIST';
export const UPDATE_HOTEL_POLICY_ADDITIONAL_DATA = 'UPDATE_HOTEL_POLICY_ADDITIONAL_DATA';
export const UPDATE_HOTEL_POLICY_ERROR = 'UPDATE_HOTEL_POLICY_ERROR';
export const UPDATE_HOTEL_POLICY_FETCH_STATUS = 'UPDATE_HOTEL_POLICY_FETCH_STATUS';

// similar hotels
export const UPDATE_SIMILAR_HOTELS_DATA = 'UPDATE_SIMILAR_HOTELS_DATA';
export const UPDATE_SIMILAR_HOTELS_ERROR = 'UPDATE_SIMILAR_HOTELS_ERROR';
export const UPDATE_SIMILAR_HOTELS_FETCH_STATUS = 'UPDATE_SIMILAR_HOTELS_FETCH_STATUS';

// About property
export const UPDATE_ABOUT_PROPERTY = 'UPDATE_ABOUT_PROPERTY';

export enum FetchStatusType {
  NOT_STARTED = 'NOT_STARTED',
  PENDING = 'PENDING',
  RESOLVED = 'RESOLVED',
  REJECTED = 'REJECTED',
}

export type SentimentType = {
  count: number;
  name: string;
  sentiment: 'POS' | 'NEG';
  tags: string[];
  rootSlug: string;
  root: string;
  id: string; // a number in a string
};

export type EmiDataType = ReturnType<typeof getCheapestRoomData>['emiData'];

export type SelectedRoomDataType = {
  roomPrice?: number;
  roomPriceAfterLogin?: number;
  emiData?: EmiDataType;
  tax?: number;
};

export type UGCSentiments = Array<{
  type: 'POS' | 'NEG';
  data: Array<SentimentType>;
}>;

// 🐨this type should stay at Details.tsx level, or maybe ever more up
// 🐨take an exhaustive list from hermes to type this
export type HQueryType = {
  ci: string;
  co: string;
  r: string; // pax
  galist?: string;
  ibp?: string;
  ld?: string;
  metaTraffic?: string;
  npvp?: string;
  sb?: number;
  ts?: number;
  pricedet?: string;
};

export interface DetailsStaticRatePlan {
  inclusions: string[];
  meal_plan: string;
  id: string;
}

export type DetailsStaticRatePlans = Array<DetailsStaticRatePlan>;
export interface BedType {
  count: number;
  type: string;
  id: number;
  types: string[];
}

// first 3 images, 4th item is some kind of room info and 5th is vendor
export type GalleryItem = [string, string, string, string, string];

export interface StaticRoomInfo {
  max_infant?: number;
  rate_plans?: DetailsStaticRatePlans;
  image?: string;
  facilities?: string[];
  bedtype?: string;
  room_count?: number;
  is_subroom?: 0 | 1;
  type_code: string;
  type_codes: string[]; // strings are ids
  max_guest?: number;
  sellable_type?: string;
  base_occ?: number;
  type_name?: string;
  roomsize?: string; // room size in string ft measurements
  vendor?: string; //🐨 vendor name, this should ideall be a union, get this info from hermes
  description?: string;
  max_child?: number;
  bed_types?: BedType[];
  gallery?: GalleryItem[];
  max_occ?: number;
  is_bathroom_shared?: 0 | 1;
  base_child?: number; // is it a 0 | 1 union?
  st?: string;
  extra_bedtype?: string;
}

export interface PersuasionType {
  pt: string; // persuasion text
  ccd: HermesColorBgColorType;
}

export type PersuasionsType = Array<PersuasionType>;

// 🐨 update this from the properties which selectors use
export interface DetailStaticShape {
  minprice?: number;
  c?: string; // hotel area selector
  vcid?: string; // hotel id
  seo_markup_data?: {
    hotel_city_url: string;
    country_url: string;
    // add more fields as you use them
  };
  map_marker: {
    mobile: string;
    desktop: string;
  };
  hn?: string; // hotel name
  ht?: string[]; // hotel type
  ty?: string;
  hr?: number; // hotel rating
  address?: string;
  finalAddress?: string;
  pincode?: string;
  cn?: string; // country
  puncode?: string;
  gr?: number; // static rating
  gir_rcnt?: number; // static no. of reviews
  gri?: number; // hotel rating source's code
  ugc_sentiments?: UGCSentiments;
  room_info?: StaticRoomInfo[];
  facilities?: {
    all: string[];
    cmapped: Array<{
      code: string;
      n: string;
    }>;
    categorized: Array<{
      data: string[];
      label: string;
    }>;
  };

  // 🐨 update these types
  gallery?: Array<any>;
  ugc_images?: Array<any>;
  gir_data?: object;
  la: number;
  lo: number;
  check_in?: string;
  check_out?: string;
  checkinFormatted?: string;
  checkoutFormatted?: string;
  poi_data: Array<{
    data: Array<{
      _id: string;
      crd: Array<[number, number]>;
      n: string;
    }>;
    title: string;
  }>;
  status: {
    http_code: number;
  };
  hotel_url: string;
}

export interface RplType {
  rwt: string;
  gsv: string;
  gseg: string;
  hmd: string;
  cnt: number;
  srty: number;
  dtc: number;
  ti: number;
  use: number;
  gtv: string;
  pd: {
    cbm: string;
    ga: string;
    ofs: string;
    pax: string;
    pph: string;
    emi?: string;
    emid?: {
      bas: number;
      tax: number;
      fin: number;
      e3: number;
      e6: number;
      e9: number;
    };
    opr: number;
    spr: number;
    do: 0 | 1;
    dspr: number;
    tp: number;
    rra: number;
    tnc: number; // tax plus conv
  };
  cp: Array<string>; // cancellation policy
  is_cp: boolean; // should show hermes cancellation policy instead of fetching fresh
  adp: number;
  // "aip": null, // don't know which type yet
  sd_code: string;
  sd_ot: string;
  sld: string;
  sb: number;
  cltxt: string;
  cltxtc: string;
  cot: string;
  cur: string;
  grpc: string;
  offercode: string;
  pc: string; // promo code
  rpc: string;
  rtc: string;
  rtn: string;
  ibp: string;
  pm: number;
  pa: number;
  am: Array<string>;
  ex?: Array<string>;
  fwdp: {
    hctx: string;
    hctxty: string;
    srctx: string;
    prgen: string;
    vhid: string;
    ps: string;
    ts: string;
  };
  fcp: {
    // free cancellation policy
    t: string; // persuasion text,
    at: string; // more info about the expiry date of refund
    fct: string; // values seen of this til now – 'fc'
  };
}

export interface RoomDataType {
  gs: string;
  rtc: string;
  rtn: string; // room type name
  arc: number;
  rpl: RplType[];
}

export interface FdElementType {
  rti: number;
  grpil: Array<number>;
}

export interface RfElementType {
  name: string;
  ic: string;
  fd: Array<FdElementType>;
  fc: string;
}

export interface VpsElementType {
  bgc: string;
  ic: string;
  st: string;
  tcc: string;
  t: string;
  tgs: Array<string>;
  pr: Array<any>;
}

type HermesColorBgColorType = {
  tc: string;
  bgc: string;
};

export interface MetaInfoType {
  gsm: string; // gostays hover data list
  flags: {
    gostay?: number;
    has_akb?: number;
    cf?: number;
    is_min_akb?: number;
    im?: number;
    pah?: number;
    pn?: number;
    rnpl?: number;
    sd?: number;
    sb?: number;
    ti?: number;
    pxgrn?: number;
    is_hp?: number;
    is_aa?: number;
    skip_room_sel?: number;
    show_sa?: number;
    lgdin?: number;
  };
  altpx: string;
  rf: Array<RfElementType>;
  ptk: string;
  ptl: {
    def: [
      {
        ic: string;
        t: string;
        img: Array<any>;
        pid: string;
      },
    ];
  };
  per: {
    rt: string;
    vbt: string;
  };
  vpc: [
    {
      btnc: string;
      bttx: string;
      bttc: string;
      desc: string;
      hcc: string;
      img: string;
      n: string;
      slug: string;
      shcc: string;
      st: string;
      t: string;
      fn: Array<any>;
    },
  ];
  vps: Array<VpsElementType>;
  akb_msg: string;
  dvthr: number;
  atyn: string;
  cta: string;
  hp: string[]; // hotel policy array
}

export interface ISelectedHotelStatic {
  hn: string;
  hc: string;
  ibp?: string;
  hmd?: string;
}

export interface DetailsHermesShape {
  data?: {
    // free cancellation persuasion data
    tlp: Array<{
      ic: string;
      pt: string;
      htd: {
        ic: string;
        h: string;
        ht: string[];
        hec: HermesColorBgColorType;
        hoc: HermesColorBgColorType;
      };
      ccd: HermesColorBgColorType;
    }>;
    reg: RoomDataType[];
    sp?: [[Assign<PersuasionType, {ic: string; iul: string[]}, PersuasionType>]];
    tp?: PersuasionsType; // persuasion near hotel rating
    cp1?: PersuasionsType; // persuasion instead of sign up persuasion ( for signed in ). This is sibling for tier persuasions. if tier persuasion is there show that, else this
    cp2?: PersuasionsType; // free breakfast / free cancellation
    cp3?: Array<
      Assign<
        PersuasionType,
        {
          ic?: string;
          h?: string;
          ht?: string[];
          hec?: PersuasionType['ccd'];
          hoc?: PersuasionType['ccd'];
        }
      >
    >; // same card, text below cp2 text
    vp?: Assign<PersuasionType, {ic: string}>; // ic: 'locpin' ; location persuasion
    npp?: Array<{
      htd: {
        ht: Array<string>;
        iu: string;
      };
      iu: string;
    }>;
  };
  meta_info: Partial<MetaInfoType>;
}

export interface DetailsStateShape {
  [x: string]: any;
  offerCodeFromQueryParam: string;
  appliedFilters: string[];
  vhid?: string;
  filter?: any;
  selectedHotelStatic?: ISelectedHotelStatic;
  hasStaticData: boolean;
  hasHermesData: boolean;
  isStaticDataLoading: boolean;
  isHermesDataLoading: boolean;
  staticData: DetailStaticShape; // 🐨 see koala comment in reducer
  hermesData: DetailsHermesShape;
  UI: {
    currentRoomData: SelectedRoomDataType;
  };
  processedAboutPropertyData: string;
  hotelPolicyData: {
    hotelPolicyList: string[];
    hotelPolicyAdditionalData: {
      [k: string]: string[];
    };
    hotelPolicyError: null | Error;
    hotelPolicyFetchStatus: FetchStatusType;
  };
  similarHotels: {
    list: SimilarHotelsAPIResponseTypes['data'];
    cityMetaInfo: SimilarHotelsAPIResponseTypes['city_meta_info'];
    error: null | Error;
    fetchStatus: FetchStatusType;
  };
}

export interface IGallery {
  s: string;
  m: string;
  b: string;
  tag: string;
}

export interface IDetailsConfig {
  vhid: DetailsStateShape['vhid'];
  selectedHotelStatic: DetailsStateShape['selectedHotelStatic'];
  filter: DetailsStateShape['filter'];
  page?: DetailsStateShape['page'];
  offerCodeFromQueryParam: DetailsStateShape['offerCodeFromQueryParam'];
}

export interface IResetDetailsData {
  type: typeof RESET_DETAILS_DATA;
}

export interface ACTION_UPDATE_DETAILS_STATIC_DATA_TYPE {
  type: typeof UPDATE_DETAILS_STATIC_DATA;
  payload: {
    staticData: DetailStaticShape;
  };
}

export interface ACTION_UPDATE_DETAILS_HERMES_DATA_TYPE {
  type: typeof UPDATE_DETAILS_HERMES_DATA;
  payload: {
    hermesData: DetailsHermesShape;
  };
}

export interface ACTION_UPDATE_DETAILS_STATIC_FETCH_STATUS_TYPE {
  type: typeof UPDATE_DETAILS_STATIC_FETCH_STATUS;
  payload: {
    isLoading: boolean;
  };
}

export interface ACTION_UPDATE_DETAILS_HERMES_FETCH_STATUS_TYPE {
  type: typeof UPDATE_DETAILS_HERMES_FETCH_STATUS;
  payload: {
    isLoading: boolean;
  };
}

export interface ACTION_UPDATE_CURRENT_ROOM {
  type: typeof UPDATE_CURRENT_ROOM;
  payload: {
    roomData: SelectedRoomDataType;
  };
}

export interface IUpdate_Details_Config_Action {
  type: typeof UPDATE_DETAILS_CONFIG;
  actionData: IDetailsConfig;
}

// export interface ACTION_UPDATE_HOTEL_POLICY_DATA_ACTION {
//   type: typeof UPDATE_HOTEL_POLICY_DATA,
//   payload: {
//     hotelPolicyData: {
//       hotelPolicyList: string[],
//       additionalData: any
//     }
//   }
// }

export interface ACTION_UPDATE_HOTEL_POLICY_LIST {
  type: typeof UPDATE_HOTEL_POLICY_LIST;
  payload: {
    hotelPolicyList: string[];
  };
}

export interface ACTION_UPDATE_HOTEL_POLICY_ADDITIONAL_DATA {
  type: typeof UPDATE_HOTEL_POLICY_ADDITIONAL_DATA;
  payload: {
    hotelPolicyAdditionalData: any;
  };
}

export interface ACTION_UPDATE_HOTEL_POLICY_ERROR {
  type: typeof UPDATE_HOTEL_POLICY_ERROR;
  payload: {
    hotelPolicyError: Error | null;
  };
}

export interface ACTION_UPDATE_HOTEL_POLICY_FETCH_STATUS {
  type: typeof UPDATE_HOTEL_POLICY_FETCH_STATUS;
  payload: {
    hotelPolicyFetchStatus: FetchStatusType;
  };
}

export interface ACTION_UPDATE_SIMILAR_HOTELS_DATA {
  type: typeof UPDATE_SIMILAR_HOTELS_DATA;
  payload: {
    list: DetailsStateShape['similarHotels']['list'];
    cityMetaInfo: DetailsStateShape['similarHotels']['cityMetaInfo'];
  };
}

export interface ACTION_UPDATE_SIMILAR_HOTELS_ERROR {
  typeof: typeof UPDATE_SIMILAR_HOTELS_ERROR;
  payload: {
    error: null | Error;
  };
}

export interface ACTION_UPDATE_SIMILAR_HOTELS_FETCH_STATUS {
  typeof: typeof UPDATE_SIMILAR_HOTELS_FETCH_STATUS;
  payload: {
    fetchStatus: FetchStatusType;
  };
}

export interface IUPDATE_UGC_IMAGES {
  type: typeof UPDATE_UGC_IMAGES;
  actionData: Array<object>;
}

export interface IUPDATE_ABOUT_PROPERTY {
  type: typeof UPDATE_ABOUT_PROPERTY;
  actionData: string;
}

export type DetailsPageActionTypes =
  | ACTION_UPDATE_DETAILS_STATIC_DATA_TYPE
  | ACTION_UPDATE_DETAILS_HERMES_DATA_TYPE
  | ACTION_UPDATE_DETAILS_STATIC_FETCH_STATUS_TYPE
  | ACTION_UPDATE_DETAILS_HERMES_FETCH_STATUS_TYPE
  | ACTION_UPDATE_CURRENT_ROOM
  | ACTION_UPDATE_HOTEL_POLICY_LIST
  | ACTION_UPDATE_HOTEL_POLICY_ADDITIONAL_DATA
  | ACTION_UPDATE_HOTEL_POLICY_ERROR
  | ACTION_UPDATE_HOTEL_POLICY_FETCH_STATUS
  | ACTION_UPDATE_SIMILAR_HOTELS_DATA
  | ACTION_UPDATE_SIMILAR_HOTELS_ERROR
  | ACTION_UPDATE_SIMILAR_HOTELS_FETCH_STATUS
  | IUpdate_Details_Config_Action
  | IUPDATE_UGC_IMAGES
  | IResetDetailsData
  | IUPDATE_ABOUT_PROPERTY;
